import * as types from '../actions';

const initialState = {    
    status:0,
    activity:'',
    errorData:'', 
    feedback:[],
    feedbackTotalPage:0,
    feedbackNumRows:0,
    feedbackCount:0,
}

export default function(state = initialState, action) {
    const response = action.response;
    let timeVar = '~~'+Date.now(); 
    switch(action.type) {

        case types.FEEDBACK_LIST_SUCCESS:
            if(response.status===200){
                let totalPage = 1
                if(response.data.results !== undefined){
                    totalPage = Math.ceil(response.data.count/response.data.page_size);
                }
                return {
                    ...state, 
                    feedback:(response.data.results === undefined ? response.data : response.data.results),
                    status: response.status,  
                    activity:types.FEEDBACK_LIST_SUCCESS+timeVar,           
                    feedbackTotalPage: (response.data.results === undefined ? 1 : totalPage),
                    feedbackNumRows:(response.data.results === undefined ? response.data.length : response.data.results.length),
                    feedbackCount:response.data.count                             
                };                
            }else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.FEEDBACK_LIST_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }     
            
        case types.FEEDBACK_DETAILS_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    feedbackDetails:response.data,
                    status: response.status,  
                    activity:types.FEEDBACK_DETAILS_SUCCESS+timeVar,                               
                };
            }
            else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.FEEDBACK_DETAILS_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }      
            
        case types.FEEDBACK_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    status: response.status,  
                    activity:types.FEEDBACK_UPDATE_SUCCESS+timeVar,                               
                };
            }
            else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.FEEDBACK_UPDATE_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }   

        case types.FEEDBACK_STAR_RATING_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    status: response.status,  
                    activity:types.FEEDBACK_STAR_RATING_SUCCESS+timeVar,                               
                };
            }
            else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.FEEDBACK_STAR_RATING_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }     
        
        case types.ACTION_TAKEN_SHIFT_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    status: response.status,  
                    activity:types.ACTION_TAKEN_SHIFT_SUCCESS+timeVar,                               
                };
            }
            else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.ACTION_TAKEN_SHIFT_ERROR+timeVar, 
                    errorData:response.data                              
                };
            } 
        
        case types.ACTION_TAKEN_SHIFT_ERROR: 
            return {
                ...state,  
                status: response.status,  
                activity:types.ACTION_TAKEN_SHIFT_ERROR+timeVar, 
                errorData:response.data                              
            };
             
              
        case types.ACTION_TAKEN_SHIFT_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    status: response.status,  
                    activity:types.ACTION_TAKEN_SHIFT_UPDATE_SUCCESS+timeVar,                               
                };
            }
            else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.ACTION_TAKEN_SHIFT_UPDATE_ERROR+timeVar, 
                    errorData:response.data                              
                };
            } 
        
        case types.ACTION_TAKEN_SHIFT_UPDATE_ERROR: 
            return {
                ...state,  
                status: response.status,  
                activity:types.ACTION_TAKEN_SHIFT_UPDATE_ERROR+timeVar, 
                errorData:response.data                              
            };
          
        case types.ACTION_TAKEN_CREW_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    status: response.status,  
                    activity:types.ACTION_TAKEN_CREW_SUCCESS+timeVar,                               
                };
            }
            else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.ACTION_TAKEN_CREW_ERROR+timeVar, 
                    errorData:response.data                              
                };
            } 
        
        case types.ACTION_TAKEN_CREW_ERROR: 
            return {
                ...state,  
                status: response.status,  
                activity:types.ACTION_TAKEN_CREW_ERROR+timeVar, 
                errorData:response.data                              
            };

        case types.ACTION_TAKEN_CREW_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    status: response.status,  
                    activity:types.ACTION_TAKEN_CREW_UPDATE_SUCCESS+timeVar,                               
                };
            }
            else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.ACTION_TAKEN_CREW_UPDATE_ERROR+timeVar, 
                    errorData:response.data                              
                };
            } 
        
        case types.ACTION_TAKEN_CREW_UPDATE_ERROR: 
            return {
                ...state,  
                status: response.status,  
                activity:types.ACTION_TAKEN_CREW_UPDATE_ERROR+timeVar, 
                errorData:response.data                              
            };

        case types.CLEAR:
            return {
                ...state,
                status:0,
                activity:types.CLEAR,
            } 
                
        default:
            return state;

    }
}